import React from "react";

export const Snowfall: React.FC = () => {
  return (
    <div className="pointer-events-none absolute inset-0 -z-0 overflow-hidden">
      <div className="h-full w-full bg-[radial-gradient(circle,_rgba(255,255,255,0.55)_1px,_transparent_1px)] bg-[length:18px_18px] opacity-60" />
    </div>
  );
};

export default Snowfall;

